<template>
  <b-card>
    <div slot="header">
      <strong>
        برای ضبط صدا ابتدا روی دکمه میکروفون (<mdicon
          name="microphone"
          size="20"
        />) کلیک کنید و همچنین بعد از پایان مکالمه روی دکمه توقف (<mdicon
          name="stop-circle"
          size="20"
        />) کلیک نمایید
      </strong>
    </div>

    <b-row>
      <b-col
        class="text-center d-flex justify-content-center align-items-center"
        cols="12"
        md="6"
      >
        <b-row>
          <b-col cols="12">
            <h5 v-if="audioTimer">
              زمان ضبط صدا
              <b class="text-danger">({{ audioTimer }})</b>
            </h5>

            <b-alert :show="isRecording" variant="danger" dismissible>
              {{
                audioTimer
                  ? $lang.voice_recorde_correct
                  : $lang.voice_recorde_notcorrect
              }}
            </b-alert>
          </b-col>
          <b-col cols="12" class="flex">
            <button
              ref="start"
              :class="isRecording ? `Rec_circle m-2` : `record_btn m-2`"
              @click="startRecording"
              :disabled="isRecording"
              class="flex-center"
            >
              <mdicon name="microphone" size="20" />
            </button>
            <button
              ref="stop"
              class="record_btn m-2 flex-center"
              @click="stopRecording"
              :disabled="!isRecording"
            >
              <mdicon name="stop" size="20" />
            </button>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="6" class="text-center">
        <audio ref="recorder" muted="true" controls hidden></audio>
        <audio ref="player" controls hidden></audio>
        <audio
          v-for="(item, i) in audios"
          :src="item"
          :key="i"
          controls
        ></audio>
        <div class="text-left w-75 m-auto" v-if="progressLoading">
          {{ $lang.search.loading_send }}
          <b-progress
            v-if="progress"
            :value="progress"
            max="100"
            show-progress
            :animated="progress == 100 ? false : true"
          />
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  inject: ["attachmentRepository"],
  props: {
    code: {
      type: [String, Number],
      default: null,
    },
    caseId: {
      type: [String, Number],
      default: null,
    },
    candidateName: {
      type: String,
      default: "",
    },
    exerciseName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      progressLoading: false,
      mediaRecorder: null,
      stream: null,
      chunks: [],
      isRecording: false,
      recorderRef: null,
      playerRef: null,
      startRef: null,
      stopRef: null,
      timerInterval: null,
      audioTimer: null,
      auidoFile: null,
      progress: 0,
      constraints: {
        audio: true,
      },
      audios: [],
    };
  },
  computed: {
    recordCaption() {
      return `صوت پرونده شماره ${this.caseId} ${this.candidateName}`;
    },
    recordDescription() {
      const name = pathOr(
        null,
        ["profile", "userInfo", "person", "name"],
        this.$store.state
      );
      const family = pathOr(
        null,
        ["profile", "userInfo", "person", "family"],
        this.$store.state
      );
      const currentUser = `${name} ${family}`;
      return `صوت ${this.exerciseName} برای ${this.candidateName} توسط ${currentUser}`;
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    async sendAudio(id, blob) {
      try {
        this.progressLoading = true;
        this.load = false;
        const file = new File([blob], `test.mp3`, {
          type: "audio/webm; codecs=lame",
        });

        const formData = new FormData();
        formData.append("file", file);
        formData.append("caption", this.recordCaption);
        formData.append("attachment_type_id", 45);
        formData.append(
          "attachment_type_name",
          "attachment_type_center_execute"
        );

        await this.attachmentRepository.create(
          formData,
          "person_content",
          id,
          {
            "Content-Type": "multipart/form-data",
          },
          true,
          {
            onUploadProgress: function (e) {
              this.progress = parseInt(Math.round((e.loaded * 100) / e.total));
            }.bind(this),
          }
        );
        this.flakUploadFile = true;
        this.$notify.success(this.$lang.upload_audio_file);
        this.$emit("getUploadFile");
        this.load = true;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.progressLoading = false;
      }
    },
    VoiceRecorder() {
      this.recorderRef = this.$refs.recorder;
      this.playerRef = this.$refs.player;
      this.startRef = this.$refs.start;
      this.stopRef = this.$refs.stop;
    },
    startTimer() {
      this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
    },
    prettyTime(t) {
      let minutes = Math.floor(t / 60);
      if (minutes < 10) minutes = "0" + minutes;
      let seconds = Math.floor(t % 60);
      if (seconds < 10) seconds = "0" + seconds;
      return `${minutes}:${seconds}`;
    },
    handleSuccess(stream) {
      this.stream = stream;
      stream.oninactive = () => {};
      this.$refs.recorder.srcObject = stream;
      this.startTimer();
      let options = {
        mimeType: "audio/webm;codec=pcm",
      };
      this.mediaRecorder = new MediaRecorder(stream, options);
      this.mediaRecorder.ondataavailable = (e) =>
        this.onMediaRecorderDataAvailable(e);
      this.mediaRecorder.onstop = (e) => this.onMediaRecorderStop(e);
      this.$refs.recorder.onaudioprocess = (e) => this.onProcess(e);

      this.$refs.recorder.ontimeupdate = (e) => {
        let time = this.$refs.recorder.currentTime;
        this.audioTimer = this.prettyTime(time);
      };

      this.$refs.recorder.play();
      this.$refs.recorder.muted = true;
      this.mediaRecorder.start();
    },
    ontimeupdate(e) {},
    onMediaRecorderDataAvailable(e) {
      this.chunks.push(e.data);
    },
    onMediaRecorderStop(e) {
      const blob = new Blob(this.chunks, {
        type: "audio/webm; codecs=lame",
      });
      const audioURL = window.URL.createObjectURL(blob);
      this.$refs.player.src = audioURL;
      this.audios.push(audioURL);
      this.chunks = [];
      this.stream.getAudioTracks().forEach((track) => track.stop());
      this.stream = null;
      this.createPersonContent(blob);
    },
    // اعلام شروع ضبط صدا
    startRecording() {
      this.isRecording = true;
      this.$refs.player.src = "";
      navigator.mediaDevices
        .getUserMedia(this.constraints)
        .then((stream) => {
          this.handleSuccess(stream);
          this.$emit("startRecording");
        })
        .catch((err) => this.$notify.error(this.$lang.audioRecorderException));
    },
    pauseRecording() {
      this.mediaRecorder.pause();
      this.$refs.recorder.pause();
    },
    stopRecording() {
      this.isRecording = false;
      this.$refs.recorder.pause();
      this.mediaRecorder.stop();
    },
    async createPersonContent(blob) {
      try {
        this.loading = true;
        const url = generateApiUrl(
          ["kanoon", "center_execute_person_content"],
          [this.caseId]
        );
        const payload = {
          name: this.recordCaption,
          description: this.recordDescription,
          reference: {
            resource: "center_execute_case",
            key: this.caseId,
          },
        };
        const response = await this.$httpService.post(url, payload);
        const id = pathOr(null, ["data", "data"], response);
        await this.sendAudio(id, blob);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.VoiceRecorder();
  },
};
</script>

<style lang="scss" scoped>
.record_btn {
  width: 45px;
  height: 45px;
  font-size: 25px;
  color: #ffffff;
  background: #424242;
  border: 2px solid #ffffff;
  border-radius: 50%;
  cursor: pointer;
  -webkit-transition: 0.15s linear;
  transition: 0.15s linear;
  line-height: 0;
}

.Rec_circle {
  width: 45px;
  height: 45px;

  font-size: 25px;
  color: #e74c3c;

  border: 2px solid #e74c3c;
  border-radius: 50%;
  cursor: pointer;
  transition: 0.15s linear;
}

.record_btn:hover {
  transition: 0.15s linear;
  transform: scale(1.05);
}

.record_btn:active {
  background: #f5f5f5;
}

.Rec_circle {
  animation-name: pulse;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes pulse {
  0% {
    box-shadow: 0px 0px 5px 0px rgba(173, 0, 0, 0.3);
  }

  65% {
    box-shadow: 0px 0px 5px 13px rgba(173, 0, 0, 0.3);
  }

  90% {
    box-shadow: 0px 0px 5px 13px rgba(173, 0, 0, 0);
  }
}
</style>
